module.exports = __webpack_public_path__ + "static/media/login_bckground_img.5b531adb.png";